import { Autoplay, EffectCoverflow } from "swiper/modules";

export const gamesShowcaseConfig = {
  modules: [Autoplay, EffectCoverflow],
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 3,
  spaceBetween: 20,

  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: false,
  },

  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 1.5,
      spaceBetween: 25,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

export const getGamesShowcaseConfig = (overrides = {}) => {
  const baseConfig = { ...gamesShowcaseConfig };

  if (overrides.autoplay && overrides.loop) {
    baseConfig.autoplay = {
      delay: overrides.autoplaySpeed || 3000,
      disableOnInteraction: false,
    };
  }

  if (overrides.loop) {
    baseConfig.loop = true;
  }

  return baseConfig;
};

export default {
  gamesShowcaseConfig,
  getGamesShowcaseConfig,
};
